import React from 'react';
import '../styles/Home.css';
import VideoRow from '../components/VideoRow';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import HeaderCarsoul from './HeaderCarsoul';
import Pagination from '@material-ui/lab/Pagination';

const HomePage = ({ onToggleDark }) => {
  return (
    <>
      <NavBar onToggleDark={onToggleDark} />
      <HeaderCarsoul />
      <div className="home">
        <div className="home__body">
          <VideoRow title="Channel A" />
          <VideoRow title="Channel B" />
          <VideoRow title="Channel C" />
          <div className="pagination">
            <Pagination
              size="large"
              count={10}
              shape="rounded"
              color="secondary"
            />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default HomePage;
